// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__BMgCe","sp-anime":"spinner_sp-anime__j42UM"};